const layout = () => import("../../internal/layout.vue");
const contract = () => import("./contract.vue");

const contractRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "contract",
      meta: {
        title: "Aditivo Contrato SITE",
        requiresAuth: true,
      },
      component: contract,
    },
  ],
};

export default contractRoutes;
